<template>
    <div class="bg-white p-4 shadow-sm rounded-lg">
        <div>
            <close-requests></close-requests>
            <Alerts :_success="success" :_error="error"></Alerts>

            <h4 class="font-weight-bold mb-3">Create a New ERP</h4>
            <div class="mb-4">
                <p class="text-muted">Choose how you would like to create a new ERP:</p>


                <div class="custom-control custom-switch mb-3">
                    <input type="radio" class="custom-control-input" value="template"
                           id="budgeting-template" v-model="method">
                    <label class="custom-control-label" for="budgeting-template">
                        Create New EP
                    </label>
                    <small class="form-text text-muted">
                        Use this option to create an new ERP.
                    </small>
                </div>

                <hr>

                <div class="custom-control custom-switch mb-3">
                    <input type="radio" class="custom-control-input" value="card"
                           id="credit-card-usage" v-model="method">
                    <label class="custom-control-label" for="credit-card-usage">
                        Create Credit Card Usage ERP
                    </label>
                    <small class="form-text text-muted">
                        Use this option to map credit card usage to specific budget lines.
                    </small>
                </div>
            </div>

            <button class="btn btn-dark" @click="proceed()" :disabled="!method">
                Proceed to {{ method == 'simple' ? 'Simple ERP'
                : (method == 'card' ? 'Credit Card' : 'Budgeting Template') }} &raquo;
            </button>&nbsp;
            <router-link to="/requests" class="btn btn-dark">Cancel</router-link>

        </div>
    </div>
</template>

<script>
import Alerts from "@/components/Alerts.vue";
import CloseRequests from "@/components/CloseRequests.vue";

export default {
    name: "PreCreateRequest",
    components: {Alerts, CloseRequests},
    data() {
        return {
            method: 'template'
        }
    },
    methods: {
        proceed() {
            if (this.method === 'template') {
                this.$router.push('/requests/budgeting')

            } else if (this.method === 'card') {
                this.$router.push('/requests/card')

            } else {
                this.$router.push('/requests/create')
            }
        }
    }
}
</script>

<style scoped>

</style>